module.exports = __webpack_public_path__ + "img/5397b1d.png";